import React from 'react';
import ReactDOM from 'react-dom';
import { Providers } from './components/Providers';
import { App } from 'src/App';

import 'what-input';
import 'src/theme/style.css';

ReactDOM.render(
    <Providers>
      <App />
    </Providers>,
  document.getElementById('root'),
);
